import React, { Component } from 'react'
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import {Link} from 'react-router'
import MediaGrid from './MediaGrid'
import OutreachCard from './OutreachCard'

import eventsConfig from '../../configs/events-config'

class OutreachDetail extends Component {
  constructor(props) {
    super(props)
    this.onMediaSelect = this.onMediaSelect.bind(this)
    this.state = { selectedIndex: null }
  }

  componentDidMount () {
    const outreachSlider = document.getElementById('outreach-slider')
    const { selectedIndex } = this.state
    let currentIndex
    if (outreachSlider) {
      outreachSlider.addEventListener('click', () => {
        setTimeout(()=> {
          currentIndex = document.getElementsByClassName('slick-active')[0].dataset.index
          if (currentIndex !== selectedIndex) {
            this.setState({ selectedIndex: currentIndex })
          }
        }, 100)
      })
    }

  }

  onMediaSelect (index) {
    this.setState({ selectedIndex: index })
  }

  render () {
    const {location, params} = this.props
    const {selectedIndex} = this.state
    const value = params.value
    const pathname = `https://mindmakersproject.org${location.pathname}`
    let event

    Object.keys(eventsConfig).forEach((key) => {
      if (eventsConfig[key].key === value) {
        event = eventsConfig[key]
      }
    })

    const {
      photos,
      videos,
      videoThumbnail
    } = event

    let media = photos || videos

    const outreachSlider = document.getElementById('outreach-slider')
    if (outreachSlider) {
      outreachSlider.addEventListener('click', () => {
        const currentIndex = document.getElementsByClassName('slick-active')[0].dataset.index
        if (selectedIndex !== currentIndex) {
          this.setState({ selectedIndex: currentIndex })
        }
      })
    }

    return (
      <div className="outreach-page">
        <div className="outreach-header detail">
          <Link to="/outreach"><button className="back-button"><ChevronLeft color="#aa82ff"/><p>./Outreach_</p></button></Link>
          <OutreachCard
            detailView={true}
            event={event}
            selectedIndex={selectedIndex}
            pathname={pathname}
          />
        </div>
        { media &&
          <div className="outreach-media">
            {
              (photos.thumbnails.length > 0) &&
              <div className="outreach-photos">
                <h3>Photo Gallery</h3>
                <MediaGrid
                  clickHandler={this.onMediaSelect}
                  columnCount={4}
                  mediaArray={photos.thumbnails}
                />
              </div>
            }
            { 
              (videos.length > 0) &&
              <div className="outreach-videos">
                <h3>Video Gallery</h3>
                <div className="imageGridItem">
                  <a onClick={() => { this.onMediaSelect(photos.src.length)}}>
                    <div className="imageWrapper" style={{backgroundImage: `url(${videoThumbnail})`}}>
                    </div>
                  </a>
                </div>
                </div>
            }
          </div>
        }
      </div>
    ) 
  }
}

export default OutreachDetail



// WEBPACK FOOTER //
// ./src/components/Outreach/OutreachDetail.js